import axios from "axios";
import moment from "moment";
import { createContext } from "react";
import { HabitRepository } from "./HabitRepository";

export const HabitRepositoryContext = createContext(new HabitRepository(axios, moment.duration(5, "seconds")))